import useIsMobile from '@hooks/use-is-mobile';

type HooksReturn = {
  headerHeight: number;
  handleScrollTo(id: string): void;
};

export const useHandleLPScroll = (): HooksReturn => {
  const isDesktopXL = !useIsMobile(1320);
  const headerHeight = isDesktopXL ? 64 : 56;

  const handleScrollTo = (id: string) => {
    const section = document.getElementById(id);
    window.scrollTo({ top: section.offsetTop - headerHeight, behavior: 'smooth' });
  };

  return { headerHeight, handleScrollTo };
};
